import React, { FC, Fragment, useState } from 'react'
import { Checkbox, CircularProgress, FormControlLabel } from '@mui/material'
import ButtonUnstyled from '@mui/base/ButtonUnstyled'
import { history } from '../../../store'
import { PAGE_DASHBOARD, PAGE_LOGIN } from '../../../constants/navigation'
import { resetStoreAction } from '../../../store/actions'
import api from '../../../api'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'

const LoginTermsAcceptForm: FC = () => {
	const { loading, setLoading, dispatch, isMounted, alert } =
		useDefaultComponentTools()
	const [accept, setAccept] = useState<boolean>(false)

	const handleCheck = (): void => {
		setAccept(!accept)
	}

	const handleClickAccept = async (): Promise<void> => {
		try {
			setLoading(true)

			await api.auth.acceptTermsOfService()

			history.replace(PAGE_DASHBOARD)
		} catch (e: any) {
			'message' in e && alert.error(e.message)
		} finally {
			isMounted() && setLoading(false)
		}
	}

	const handleClickCancel = (): void => {
		dispatch(resetStoreAction())
		history.replace(PAGE_LOGIN)
	}

	return (
		<Fragment>
			<FormControlLabel
				control={<Checkbox value={accept} onChange={handleCheck} />}
				label='I accept Dario Engage terms of service'
				disabled={loading}
			/>

			<ButtonUnstyled
				variant='outlined'
				disabled={loading}
				color={'secondary'}
				size={'small'}
				style={{ minWidth: '5.625rem' }}
				onClick={handleClickCancel}
			>
				CANCEL
			</ButtonUnstyled>

			<ButtonUnstyled
				disabled={!accept || loading}
				variant='outlined'
				color={'secondary'}
				size={'small'}
				onClick={handleClickAccept}
				style={{ minWidth: '5.625rem' }}
			>
				{loading ? <CircularProgress size={14} /> : 'ACCEPT'}
			</ButtonUnstyled>
		</Fragment>
	)
}

export default LoginTermsAcceptForm
